import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Object:", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Bijlages", -1)

import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import Filelist from '@/components/Filelist.vue'
import Banner from '@/components/Banner.vue'
import NewComment from '@/components/message/NewComment.vue'
import Comments from '@/components/message/Comments.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageShow',
  setup(__props) {

const route = useRoute()
const loading = ref(false)
const message = ref({
  title: null,
  body: null,
  can_respond: false,
  project: null,
  building: null,
  status: null,
  published_at: null,
  read_at: null,
  media: [],
  comments: []
})

onMounted(() => {
  getMessage()
})

function getMessage () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/messages/' + route.params.messageId + '/tenant').then((res) => {
    message.value = res.data.data
    markMessageAsRead()
  }).finally(() => {
    loading.value = false
  })
}

function markMessageAsRead () : void {
  axios.post(process.env.VUE_APP_API_URL + '/messages/' + route.params.messageId + '/read')
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Bericht van verhuurder",
            bordered: false,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              (message.value.building)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [32,32]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createTextVNode(" " + _toDisplayString(message.value.building.address) + ", " + _toDisplayString(message.value.building.zipcode) + " " + _toDisplayString(message.value.building.city), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(message.value.title), 1),
                      _createElementVNode("div", {
                        innerHTML: message.value.body
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (message.value.media.length)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 1,
                    gutter: [32,32]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(Filelist, {
                            "media-items": message.value.media
                          }, null, 8, ["media-items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"]),
          (message.value.can_respond)
            ? (_openBlock(), _createBlock(_component_a_card, {
                key: 0,
                title: "Reactie toevoegen",
                bordered: false,
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [32,32] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(NewComment, {
                            "message-id": _unref(route).params.messageId,
                            onCommentCreated: getMessage
                          }, null, 8, ["message-id"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (message.value && message.value.comments.length)
            ? (_openBlock(), _createBlock(_component_a_card, {
                key: 1,
                title: `Reacties (${message.value.comments.length})`,
                bordered: false,
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [32,32] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(Comments, {
                            comments: message.value.comments
                          }, null, 8, ["comments"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})